module.exports = __webpack_public_path__ + "img/BUILD PLATE.c49e2418.svg";